import { render, staticRenderFns } from "./AboutAlliances1.vue?vue&type=template&id=0959543a&scoped=true&"
import script from "./AboutAlliances1.vue?vue&type=script&lang=js&"
export * from "./AboutAlliances1.vue?vue&type=script&lang=js&"
import style0 from "./AboutAlliances1.vue?vue&type=style&index=0&id=0959543a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0959543a",
  null
  
)

export default component.exports